import Vue from 'vue';
import VueCustomScrollbar from 'vue-custom-scrollbar';
import 'vue-custom-scrollbar/dist/vueScrollbar.css';

Vue.component('VueCustomScrollbar', VueCustomScrollbar);
